<template>
  <div class="aboutUs">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="content">
      <div class="menu">
        <div @click="changeTabs(item)" class="menu-item flex-center" :class="{'menu-item-select':menuSelectName==item.name}" v-for="item in menu" :key="item.name">{{item.name}}</div>
      </div>
      <div style="flex:1">
        <!-- <div class="title">入会说明</div> -->
        <div class="text" v-html="text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue';
import {queryForm} from '@/api/api.js';
export default {
  components:{
    sectionTitle
  },
  data(){
    return {
      menuSelectName:'入会说明',
      titleObj:{
        title:'会员中心',
        subtitle:'MEMBER CENTER'
      },
      menu:[
        {
          name:'入会说明'
        },
        {
          name:'会费缴交'
        },
        {
          name:'会员权利'
        },
        {
          name:'会员义务'
        },
        {
          name:'会员除名'
        },
        {
          name:'单位会员名单'
        },
        {
          name:'个人会员名单'
        },
         {
          name:'会员自律'
        },
      ],
      textData:{},
      text:''
      // text:'一、入会条件</br>根据攀枝花东区社会工作协会的章程，协会主要从以下两方面发展会员：</br>（一）从事社会工作、社会服务的社工机构，社会福利、社会公益服务的团体，社会工作理论研究和教育的高等学校可申请加入本会，成为单位会员；</br>（二）社会工作、社会服务的从业人员，从事社会工作理论研究和教育的学者，热心公益慈善服务和社会工作服务，且具有社会影响力的社会知名人士可申请加入本会，成为个人会员。</br>二、入会程序如果您想加入我们这个快乐的社工大家庭，请根据自己的情况，下载相应入会申请表，填好之后，并附上相关资料，以附件形式发送邮件至协会会员服务中心邮箱gzsxhuiyuan@gzsg.org。</br>（一）单位会员</br>单位会员申请需提交以下资料（电子版）：</br>（1）有单位盖章及法定代表人签名的单位会员申请表</br>（2）民办非企业单位登记证书（三证合一）</br>（3）法定代表人个人简历</br>（4）法定代表人证明书</br>（5）现承接政府购买服务项目的相关介绍单位会员审批通过后，我们将会以邮件或电话方式通知贵单位联系人到现场提交已盖章的申请表及相关材料纸质版原件，现场材料确认后，将发放会员证书给单位会员。</br></br> （二）个人会员</br>个人审批通过后，我们将会用邮件或电话的方式通知您，把附有本人签名的纸质版个人会员申请表（需要附上个人照片）邮寄至广州市社会工作协会（攀枝花市市东区环市西路68号4楼 020-86475767 会员部 收） ，并缴交会费。</br> </br><p style="color:#2C99FF">入会申请</p></br></br>如有其他疑问，欢迎致电020-86475767（会员中心）</br>工作时间：周一至周五09:00-12:00,14:00-17:00'
    }
  },
   created(){
    this.getInfo()
  },
   methods:{
    changeTabs(data){
       this.menuSelectName=data.name
       if(!(this.textData[this.menuSelectName])){
          this.getInfo()
        }else{
          this.text=this.textData[this.menuSelectName]
        }
    },
    getInfo(){
      queryForm({
        "formKey": "t3DIiFFv",
        "queryId": "277",
        "queryParams": {
          "select1766543680450label": this.menuSelectName
        },
        "size": 1,
        "current": 0
      }).then(res=>{
        if(res.data.code==200){
          this.textData[this.menuSelectName]=res.data.data.rows.length>0?res.data.data.rows[0].rich_text1766543754269:'暂无内容'
          this.text=this.textData[this.menuSelectName]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  padding:0 10%;
  padding-bottom: 109px;
}
.content{
  gap:64px;
  display: flex;
  .menu{
    display: flex;
    flex-direction: column;
    gap:8px;
    .menu-item{
      width: 257px;
      height: 64px;
      background: #f3f1ef;
      cursor: pointer;
      font-size: 20px;
      color:#333333;
    }
    .menu-item-select{
      background: #ed9d26;
      color:#FFFFFF;
    }
  }
  .title{
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
  }
  .introduce{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
  .text{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
}


</style>